import React from 'react';
import {
  Button,
  Form,
  Select,
  Spin,
  Row,
  Col,
} from 'antd';
import {
  DmsTab,
} from '../../components';
import  * as echarts from 'echarts';
import {
  dmsPurchaseList,
  financialReport,
} from '../../service/reportForm';
import { fetchChannelList } from '../../service/home';

const FormItem = Form.Item;
const labelOption = {
  show: true,
  position: 'top',
  distance: 15,
  align: 'center',
  verticalAlign: 'middle',
  // rotate: 90,
  // formatter: '{c}  {name|{a}}',
  formatter: '{c}',
  // fontSize: 16,
  // rich: {
  //   name: {
  //     textBorderColor: '#fff',
  //   },
  // },
};

class CustomerInvoice extends React.Component {
  constructor(props) {
    super(props);
    this.channelId = window.sessionStorage.getItem('cur_channelId');
    this.state = {
      channelCode: this.channelId,
      searchObj: {
        'salesUnitId': '', //购货单位
        'channelCode': 'ALL', //渠道编码默认ALL，如WJH，HY数据取自/xweb/api/v1/dms/homePage/channel接口（必填）
      },
      data: {},
      loading: false,
    };
    this.initData = this.initData.bind(this);
    this.advanceReset = this.advanceReset.bind(this);
    this.advanceSubmit = this.advanceSubmit.bind(this);
    this.renderChart1 = this.renderChart1.bind(this);
    this.renderChart2 = this.renderChart2.bind(this);
    this.renderChart3 = this.renderChart3.bind(this);
  }

  advanceReset(e) {
    e.preventDefault();
    let self = this;
    self.setState({
      searchObj: {
        'channelCode': 'ALL', //渠道编码默认ALL，如WJH，HY数据取自/xweb/api/v1/dms/homePage/channel接口（必填）
        'salesUnitId': '',  //购货单位
      },
    }, function () {
      self.props.form.resetFields();
      self.initData();
    });
  };

  advanceSubmit(e) {
    e.preventDefault();
    /* 筛选确认 */
    let self = this;
    let values = this.props.form.getFieldsValue();
    this.setState({
      searchObj: {
        ...this.state.searchObj,
        ...values,
      },
    }, function () {
      self.initData();
    });
  };

  initData() {
    let searchObj = this.state.searchObj;
    this.setState({ loading: true });
    financialReport(searchObj).then((result) => {
      if (result.data && result.data[0] ? result.data[0] : []) {
        this.renderChart1(result.data[0]);
        this.renderChart2(result.data[0]);
        this.renderChart3(result.data[0]);
        this.setState({
          data: result.data && result.data[0] ? result.data[0] : [],
          loading: false,
        });
      } else {
      }
    });
  }

  componentDidMount() {
    let self = this;
    this.initData();
    /*渠道类型*/
    fetchChannelList().then(res => { //渠道
      if (res.status) {
        let arr = [];
        res.data.forEach(x => {
          arr.push({
            text: x.name,
            value: x.code,
          });
        });
        self.setState({ channel_type: arr },
        );
      }
    });

    dmsPurchaseList({channelCode: this.state.channelCode, p: 1, s: 100}).then(res => { //购货单位
      if (res.status) {
        let arr = [
          {
            text: '全部',
            value: ''
          }
        ];
        for (let i = 0; i < res.data.length; i++) {
          let x = res.data[i];
          arr.push({
            text: x.name,
            value: `${x.id}`
          })
        }
        self.setState({buy_org: arr})
      }
    });
  }

  renderChart1(data) {
    const chart1 = echarts.init(document.getElementById('chart1'));
    chart1.clear();
    chart1.setOption({
      /*title: {
       text: `${start} - ${end}招商客户总数`,
       // subtext: '数据来自西安兰特水电测控技术有限公司',
       left: 'center',
       },*/
      color: [
       '#9d5ae5', '#5a95db', '#7dbb00', '#ffbb00', '#f75314',
       '#b00454', '#00a1f1', '#02c1a5', '#efee18', '#dd0527',
       ],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      grid: [
        {
          top: 50,
          left: 100,
          right: 50,
          height: '75%',
        },
      ],
      xAxis: [
        {
          type: 'category',
          axisTick: { show: false },
          data: ['期末欠款', '逾期金额'],
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: '单位：万元',
          minInterval: 1,
        },
      ],
      series: [
        {
          type: 'bar',
          label: labelOption,
          barWidth: '40%',
          data: [
            data.QMQK || 0, data.YQJE || 0,
          ],
          itemStyle: {
            normal: {
              //这里是重点
              color: function (params) {
                //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                var colorList = ['#9d5ae5', '#5a95db'];
                return colorList[params.dataIndex];
              },
            },
          },
        },
      ],
    });
  }

  renderChart2(data) {
    const chart2 = echarts.init(document.getElementById('chart2'));
    chart2.clear();
    chart2.setOption({
      /*title: {
       text: `${start} - ${end}招商客户总数`,
       // subtext: '数据来自西安兰特水电测控技术有限公司',
       left: 'center',
       },*/
      /*color: [
       '#9d5ae5', '#5a95db', '#7dbb00', '#ffbb00', '#f75314',
       '#b00454', '#00a1f1', '#02c1a5', '#efee18', '#dd0527',
       ],*/
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      grid: [
        {
          top: 50,
          left: 100,
          right: 50,
          height: '75%',
        },
      ],
      xAxis: [
        {
          type: 'category',
          axisTick: { show: false },
          data: ['本月回款', '本年回款'],
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: '单位：万元',
          minInterval: 1,
        },
      ],
      series: [
        {
          type: 'bar',
          label: labelOption,
          barWidth: '40%',
          data: [
            data.BYHK || 0, data.BNHK || 0,
          ],
          itemStyle: {
            normal: {
              //这里是重点
              color: function (params) {
                //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                var colorList = ['#7dbb00', '#02c1a5'];
                return colorList[params.dataIndex];
              },
            },
          },
        },
      ],
    });
  }

  renderChart3(data) {
    const chart3 = echarts.init(document.getElementById('chart3'));
    chart3.clear();
    chart3.setOption({
      /*title: {
       text: `${start} - ${end}招商客户总数`,
       // subtext: '数据来自西安兰特水电测控技术有限公司',
       left: 'center',
       },*/
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      grid: [
        {
          top: 50,
          left: 100,
          right: 50,
          height: '75%',
        },
      ],
      xAxis: [
        {
          type: 'category',
          axisTick: { show: false },
          data: ['本年已开票', '本年剩余未开票', '历史累计未开票'],
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: '单位：万元',
          minInterval: 1,
        },
      ],
      series: [
        {
          type: 'bar',
          label: labelOption,
          barWidth: '40%',
          data: [
            data.NDYKP || 0, data.NKWKP || 0, data.LJWKP || 0,
          ],
          itemStyle: {
            normal: {
              //这里是重点
              color: function (params) {
                //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                var colorList = ['#5a95db', '#ffbb00', '#f75314'];
                return colorList[params.dataIndex];
              },
            },
          },
        },
      ],
    });
  }

  render() {
    const { searchObj, channel_type, loading, buy_org } = this.state;
    const { getFieldDecorator } = this.props.form;
    return <Spin spinning={loading}>
      <div style={{ background: '#fff' }}>
        <DmsTab options={['财务报表']} defaultKey={0} />
        <div className="advanceForm-box">
          <div className="advanceForm-content">
            <Form layout="inline" onSubmit={this.advanceSubmit}>
              <FormItem label="渠道">
                {
                  getFieldDecorator('channelCode', {
                    initialValue: searchObj.channelCode,
                  })(<Select style={{ width: 220 }}>{
                    (channel_type || []).map(x => <Select.Option key={x.value}>{x.text}</Select.Option>)
                  }</Select>)
                }
              </FormItem>
              <FormItem label='购货单位'>
                {
                  getFieldDecorator('salesUnitId', {
                    initialValue: searchObj.salesUnitId,
                  })(<Select style={{ width: 200 }}>{
                    (buy_org || []).map((x, index) => <Select.Option key={index} value={x.value}>{x.text}</Select.Option>)
                  }</Select>)
                }
              </FormItem>
              <FormItem>
                &emsp;&emsp;&emsp;
                <Button onClick={this.advanceReset}>
                  重置
                </Button>
                &emsp;&emsp;&emsp;
                <Button
                  type="primary"
                  htmlType="submit"
                >
                  筛选
                </Button>
              </FormItem>
            </Form>
          </div>
        </div>
        <div className="dms-split-bar" />
        <div className="dms-table-box">
          <Row gutter={16}>
            <Col span={12}>
              <div className="dms-box-head">欠款情况</div>
              <div className="dms-table-box"
                   id="chart1"
                   style={{ width: '100%', height: 500, overflow: 'hidden' }}></div>
            </Col>
            <Col span={12}>
              <div className="dms-box-head">回款情况</div>
              <div className="dms-table-box"
                   id="chart2"
                   style={{ width: '100%', height: 500, overflow: 'hidden' }}></div>
            </Col>
            <Col span={12}>
              <div className="dms-box-head">开票情况</div>
              <div className="dms-table-box"
                   id="chart3"
                   style={{ width: '100%', height: 500, overflow: 'hidden' }}></div>
            </Col>
          </Row>
        </div>
      </div>
    </Spin>;
  }
}
;
export default Form.create()(CustomerInvoice);



// WEBPACK FOOTER //
// ./src/routes/reportForm/FinanceChart.js